import React from "react";
import { Languages } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

export default function LanguageToggle({ loading = false }) {
  const { lang, toggle, t } = useLanguage();
  return (
    <button
      data-testid="language-toggle"
      onClick={toggle}
      disabled={loading}
      className="fixed bottom-6 end-6 z-50 rounded-full shadow-xl border border-white/40 backdrop-blur-xl bg-white/85 px-5 py-3 flex items-center gap-2 text-sage font-semibold hover:bg-white hover:shadow-2xl hover:-translate-y-0.5 transition-all cursor-pointer disabled:opacity-60"
      aria-label="Toggle language"
    >
      <Languages className="w-5 h-5" strokeWidth={1.8} />
      <span className="tracking-wide">
        {loading ? t("translating") : lang === "en" ? "العربية" : "English"}
      </span>
      <span className="inline-flex items-center justify-center rounded-full bg-sage text-white text-[10px] font-bold w-6 h-6 ms-1">
        {lang === "en" ? "ع" : "A"}
      </span>
    </button>
  );
}
